<!--赖传峰-->
<!--2022/4/6-->
<template>
  <a
    class="pp-link-button"
    @click="i18nListVisible = !i18nListVisible"
  >
    {{ localeName }}
    <RightIcon :style="{ transform: i18nListVisible ? 'rotate(90deg)' : 'unset' }" />
  </a>
  <div
    v-show="i18nListVisible"
    class="i18n-list"
  >
    <I18nMenuList />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, useNuxtApp, watch } from '#imports'
import { useLayout } from '@/store/layout'
import RightIcon from '~/components/icons/RightIcon.vue'
import I18nMenuList from '../basic/I18nMenuList.vue'

const { locale, locales } = useNuxtApp().$i18n
const localeName = computed(() => (locales.value as Locales).find(el => el.code === locale.value)?.name)
const i18nListVisible = ref(false)
const layoutStore = useLayout()

watch(
  () => layoutStore.sidebarMobileVisible,
  val => {
    !val && (i18nListVisible.value = false)
  },
)
</script>

<style lang="less" scoped>
.pp-link-button {
  justify-content: space-between;
  margin-left: 14px;
  height: 44px;
}
</style>
